
let language = {
    PREVIEW_MODAL_IMAGE_TYPE_TITLE: "Image/",
    PREVIEW_MODAL_EDIT_FILE_NAME_TITLE: "Edit file name",
    
    // 
    PREVIEW_MODAL_DOWNLOAD_BTN: "Download",
    PREVIEW_MODAL_VIEW_SIZE_BTN: "View size",
    PREVIEW_MODAL_DELETE_BTN: "Delete",
    PREVIEW_MODAL_CANCEL_BTN: "Cancel",
    PREVIEW_MODAL_SAVE_BTN: "Ok",
    
    // 
    PREVIEW_MODAL_FILE_NAME_CAN_NOT_EMPTY_TIP: "The file name can not be empty!",
    PREVIEW_MODAL_FILE_NAME_DUPLICATE_TIP: "The file name is duplicated!",
    PREVIEW_MODAL_FILE_NAME_PATTERN_TIP: "The file name cannot contain the following characters: \\ \/ \: \* \? \" \< \> \|",
    
    PREVIEW_MODAL_DELETE_ITEM_ALERT_TITLE: "Delete file",
    PREVIEW_MODAL_DELETE_ITEM_ALERT_CONTENT: "Are you sure to delete selected file?",
};

export { language }